export default "__VITE_ASSET__d5b15f83__"